module.exports = __webpack_public_path__ + "img/BJ.de737530.svg";